<template>
    <AppModal :name="name" :width="400">
        <template v-slot:header>
            Create document subtype
        </template>

        <template v-slot:content>
            <div class="form-group text-left">
                <label for="item-name">
                    Name
                </label>
                <input v-model.trim="subtype.display"
                       @input="vuelidateDelayTouch($v.subtype.display, touchMap)"
                       type="text"
                       id="item-name"
                       class="form-control"
                       placeholder="Name">
                <span v-if="$v.subtype.display.$error" class="form-text text-danger">
                    This field is required
                </span>
            </div>
        </template>

        <template v-slot:actions>
            <div class="row justify-content-end mx-0 mt-3">
                <button @click="$modal.hide(name)" class="btn btn-link">Cancel</button>
                <button @click="add" v-loading.btn="isLoading" class="btn btn-primary">
                    Add
                </button>
            </div>
        </template>
    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {generateDocSubtypeKeyByName} from '@/views/documents/subtypes/index'
import {documentTypesApiService} from '@/api/document/types'
import {showErrorMessage} from '@/services/snackbar'

export default {
    name: 'DocSubtypeCreate',
    props: {
        name: {
            type: String,
            required: true
        },
        docTypeKey: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            subtype: {
                display: ''
            },

            isLoading: false,
            touchMap: new WeakMap()
        }
    },
    validations: {
        subtype: {
            display: {
                required
            }
        }
    },
    methods: {
        beforeOpen({params}) {
        },

        async add() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            this.isLoading = true
            const payload = {
                display: this.subtype.display,
                property: generateDocSubtypeKeyByName(this.subtype.display), // doc subtype
                section: this.docTypeKey, // doc type
                isHidden: false,
                isDefaultPurchasing: false,
                isDefaultSales: false,
                settings: {
                    sections: [],
                    fields: [],
                    extensions: []
                }
            }

            const {error} = await documentTypesApiService.writeSubtype(this.docTypeKey, payload)
            if (error) {
                showErrorMessage('Failed to create subtype')
            } else {
                this.$emit('refresh')
                this.$modal.hide(this.name)
            }
            this.isLoading = false
        }
    }
}
</script>
